export interface UnpairedContext {
  viewerId?: string | null;
  /** Everyone the viewer has already played a position with. Missing means the list has not loaded. */
  positionPartnerIds?: readonly string[] | null;
  /** A position played since the partner list was fetched. */
  hasPlayedLivePosition?: (playerId: string) => boolean;
}

/** True only when this other player has never played a position with the viewer. */
export function isPlayerUnpaired(playerId: string | null | undefined, context: UnpairedContext): boolean {
  if (!playerId || !context.viewerId || playerId === context.viewerId) return false;
  if (!context.positionPartnerIds) return false;
  if (context.positionPartnerIds.includes(playerId)) return false;
  return !context.hasPlayedLivePosition?.(playerId);
}

/** True when any other player in the list is still unpaired with the viewer. */
export function hasUnpairedPlayer(playerIds: Array<string | null | undefined>, context: UnpairedContext): boolean {
  return playerIds.some((playerId) => isPlayerUnpaired(playerId, context));
}
